import { useState } from "react";
import { useHistory } from "react-router";
import axios from 'axios'
import { useUser } from "../../providers/UserContext";

import {
  Container,
  LogoImg,
  InputContainer,
  H1Login,
  ContainerInput,
  InputLogin,
  ContainerButtonLogin,
  ButtonLogin,
  ContainerButtonWeb,
  ImgWeb,
  SmallFooter,
} from "./style";

const Login = () => {
  const history = useHistory();

  const [password, setPassword] = useState('')
  const [email, setEmail] = useState('')
  const [error, setError] = useState('')

  const api = axios.create({
    baseURL: "https://sistemas.sisinfor.com.br/BusinessGameBack"
  })

  const { user, Login } = useUser();

  const handleOnSubmit = (e) => {
    e.preventDefault();

    const data = {
      login: email,
      senha: password,
      tipo: 'Admin'
    }

    api.post(
      "/login",
      data
    )
    .then(response => {
      Login(response.data);
      history.push("/home")
    })
    .catch(
      function (error) {
      
        console.log(Promise.reject(error))
        setError('Email ou senha incorretos!')
        return Promise.reject(error)

      }
    )
  };

  // api.get("/api/usuario/listarTodos")
  // .then(response => console.log(response))


  return (
    <Container>
      <LogoImg src="./images/logo.svg" />
      <InputContainer>
        <H1Login>Console Admin</H1Login>

        <ContainerInput onSubmit={handleOnSubmit}>
          <InputLogin
            type="email"
            name="email"
            autoComplete="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <InputLogin 
            type="password" 
            name="password" 
            placeholder="Senha" 
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <span>{error}</span>
          <ContainerButtonLogin>
            
              <ButtonLogin type="submit" >
                Entrar
              </ButtonLogin>
            {/* <ButtonLogin onClick={() => history.push("/register")}>
              Cadastrar
            </ButtonLogin> */}
          </ContainerButtonLogin>
        </ContainerInput>
      </InputContainer>
      <ContainerButtonWeb>
        <a href="https://mail.google.com/mail/u/0/#inbox" target="blank">
          <ImgWeb src="./images/button_gmail.svg" />
        </a>
        <a href="https://facebook.com" target="blank">
          <ImgWeb src="./images/button_face.svg" />
        </a>
      </ContainerButtonWeb>
      <SmallFooter>Powered by Mercadata Digital</SmallFooter>
    </Container>
  );
};
export default Login;
